export default __webpack_public_path__ + "static/media/9.40cb2645.jpeg";